// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const hasCompletedCustomerSelectionKey = "hasCompletedCustomerSelection";

export const getHasCompletedCustomerSelection = () => {
    if (typeof window === "undefined") {
        return false;
    }

    return window.sessionStorage.getItem(hasCompletedCustomerSelectionKey) === "true";
};

export const setHasCompletedCustomerSelection = (hasCompletedSelection: boolean) => {
    if (typeof window === "undefined") {
        return;
    }

    window.sessionStorage.setItem(hasCompletedCustomerSelectionKey, hasCompletedSelection ? "true" : "false");
};
